import { render } from "./PengaturanJadwalAssessment.vue?vue&type=template&id=1fc749e4"
import script from "./PengaturanJadwalAssessment.vue?vue&type=script&lang=js"
export * from "./PengaturanJadwalAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__